import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './VineyardList.css';

function Vineyards({ functions, states }) {
    const {
        register,
        formState: { errors },
    } = functions;
    const { user, viniedos, tableData } = states;

    return (
        <div className="vineyardList-container">
            {viniedos.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : user.tipo !== 3 ? (
                'No tiene viñedos asignados'
            ) : (
                ''
            )}
        </div>
    );
}

export default Vineyards;
